import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Form, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../../config";
import ExportExcel from "../../../utility/ExportCSV";
import enableTableSearch from "../../../utility/tableSearch";
import { authFetch } from "../../../utility/authFetch";

function DoctorTable({ onEdit, reload }) {
  const [data, setData] = useState([]);
  const inputRef = useRef();
  const tableRef = useRef();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await authFetch(`${API_BASE_URL}/api/doctors`);
        const result = await response.json();
        setData(result.doctors || []);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDoctors();
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No problem found",
    });

    return cleanup;
  }, [loading]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <ExportExcel tableId="doctorTable" filename="doctor_report.xlsx" />
        <Form.Control
          type="text"
          placeholder="Search"
          style={{ width: "200px" }}
          ref={inputRef}
        />
      </div>

      {loading ? (
        <div className="text-center py-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Table striped bordered hover id="doctorTable" ref={tableRef}>
          <thead>
            <tr>
              <th style={{ width: "100px" }}>Action</th>
              <th>Name</th>
              <th>Category</th>
              <th>Fees</th>
              <th>Next PayDay</th>
              <th>Offline Booking Limit</th>
              <th>Online Booking Limit</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center">
                  No records found
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Button variant="warning" onClick={() => onEdit(item)}>
                      EDIT
                    </Button>
                  </td>
                  <td>{item.name}</td>
                  <td>{item.category}</td>
                  <td>{item.fees}</td>
                  <td>{item.nextPayDay}</td>
                  <td>{item.offlineLimit}</td>
                  <td>{item.onlineLimit}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </>
  );
}

export default DoctorTable;
